export const intlPolyfill = () => {
  if (!window.Intl) {
    require("intl");
    require("intl/locale-data/jsonp/cs");
    require("intl/locale-data/jsonp/da");
    require("intl/locale-data/jsonp/de");
    require("intl/locale-data/jsonp/en");
    require("intl/locale-data/jsonp/es");
    require("intl/locale-data/jsonp/fr");
    require("intl/locale-data/jsonp/hu");
    require("intl/locale-data/jsonp/it");
    require("intl/locale-data/jsonp/ja");
    require("intl/locale-data/jsonp/ko");
    require("intl/locale-data/jsonp/lt");
    require("intl/locale-data/jsonp/mr");
    require("intl/locale-data/jsonp/uk");
    require("intl/locale-data/jsonp/ms");
    require("intl/locale-data/jsonp/nl");
    require("intl/locale-data/jsonp/pl");
    require("intl/locale-data/jsonp/pt");
    require("intl/locale-data/jsonp/ru");
    require("intl/locale-data/jsonp/sk");
    require("intl/locale-data/jsonp/th");
    require("intl/locale-data/jsonp/tr");
    require("intl/locale-data/jsonp/vi");
    require("intl/locale-data/jsonp/zh");
    require("intl/locale-data/jsonp/lv");
  }
};
